import ky from 'ky';
import { env } from '@shared/config/env';
import { tokenStorage, type AuthTokens, ADMIN_PREFIX } from '@shared/api';

interface RawRefreshResponse {
  accessToken: string;
  refreshToken: string;
  expiresIn: number;
  refreshExpiresIn: number;
}

export async function refreshTokens(): Promise<AuthTokens | null> {
  const refreshToken = tokenStorage.getRefresh();
  if (!refreshToken) return null;
  try {
    const raw = await ky
      .post(`${env.apiBaseUrl}${ADMIN_PREFIX}/auth/refresh`, {
        json: { refreshToken },
        retry: 0,
        // Defensive: never carry a (likely expired) Bearer into a refresh call.
        hooks: {
          beforeRequest: [(req) => req.headers.delete('Authorization')],
        },
      })
      .json<RawRefreshResponse>();
    const tokens: AuthTokens = {
      accessToken: raw.accessToken,
      refreshToken: raw.refreshToken,
      expiresIn: raw.expiresIn,
      refreshExpiresIn: raw.refreshExpiresIn,
    };
    tokenStorage.set(tokens);
    return tokens;
  } catch {
    tokenStorage.clear();
    return null;
  }
}
